// src/components/ListRowItem.js
import React from "react";
import { motion } from "framer-motion";
import "./ListRowItem.css";

const ListRowItem = ({
  itemType = "exercise",
  x,
  id,
  isMarked,
  isFav,
  title,
  subtitle,
  onItemClick,
  onToggleMarked,
  onToggleFavorite,
  markedClassName = "done",
  markTitle,
  MarkIcon,
  showFavorites,
  FavIcon,
  FavIconFilled,
}) => {
  
  // Logical check for inactive plans
  const isInactivePlan = itemType === "plan" && x?.isActive === false;
  
  // Logic for goal-specific styling
  const goalClass = (itemType === "plan" && x?.goal) ? `goal-${x.goal}` : "";

  const containerClasses = [
    "list-item",
    `list-item--${itemType}`,
    goalClass,
    isInactivePlan ? "list-item--inactive" : "",
    isMarked ? markedClassName : ""
  ].join(" ");

  return (
    <motion.div
      className={containerClasses}
      layout
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.2 }}
    >
      <div className="title-wrap">
        {showFavorites && onToggleFavorite && (
          <button
            type="button"
            className="fav-btn"
            onClick={(e) => {
              e.stopPropagation();
              onToggleFavorite(id);
            }}
            aria-pressed={isFav}
          >
            {isFav ? <FavIconFilled size={20} /> : <FavIcon size={20} />}
          </button>
        )}

        <button
          type="button"
          className="item-btn"
          onClick={() => onItemClick?.(x)}
        >
          <div className="item-text-container">
            <span className="item-title">{title}</span>
            {subtitle && <span className="item-subtitle">{subtitle}</span>}
          </div>
        </button>

        <div className="chip-row">
          {onToggleMarked && MarkIcon && (
            <button
              type="button"
              className={`chip icon-btn ${isMarked ? "done" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                onToggleMarked(id);
              }}
              title={markTitle?.(isMarked)}
            >
              <MarkIcon size={20} />
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ListRowItem;